// import {global_axi } from "../utils";
import { back_office_axi } from "../context/authContext";

export const getClientByNetwork = async (network) => {
  if (network) {
    try {
      const response = await back_office_axi.get(
        `/api/clients/get-client-profile-by-network/${network}`,
      );
      return response;
    } catch (error) {
      console.error("Error fetching client list:", error);
      throw error;
    }
  }
};

export const getClientProfileByUserId = async (userId) => {
  if (userId) {
    try {
      const response = await back_office_axi.get(
        `/api/client/get-client-profile/${userId}`,
      );
      return response;
    } catch (error) {
      console.error("Error fetching client profile by user id:", error);
      throw error;
    }
  }
};

export const getClientProfileByEmail = async (email) => {
  if (email) {
    try {
      const response = await back_office_axi.get(
        `/api/clients/get-client-profile-by-email?email=${encodeURIComponent(email)}`,
      );
      return response;
    } catch (error) {
      console.error("Error fetching client profile by email:", error);
      throw error;
    }
  }
};

export const fetchGates = async (clientId) => {
  try {
    const response = await back_office_axi.get(
      `/api/licenses/has-valid-license/${clientId}`,
    );
    return response;
  } catch (error) {
    console.log(
      "Error fetching data:".error?.message || error.response.message,
    );
    throw error;
  }
};

export const fetchActiveLicenses = async (clientId) => {
  try {
    const response = await back_office_axi.get(
      `/api/licenses/get-active-license/${clientId}`,
    );
    return response;
  } catch (error) {
    console.log(
      "Error fetching data:".error?.message || error.response.message,
    );
    throw error;
  }
};
